import { useEffect, useState, useCallback } from "react";
import { setIsLoading } from "../redux/slice";
import { useDispatch } from "react-redux";

export const usePaytmJSCheckout = (url, data) => {
  const dispatch = useDispatch();
  let [state, setState] = useState(url ? "loading" : "idle");
  let [scriptLoaded, setScriptLoaded] = useState(false);
  const handleScript = useCallback(
    (e, txnAmount) => {
      let clone = { ...data };
      clone.amount = txnAmount;
      setState(e.type === "load" ? "ready" : "error");
      var config = {
        root: "",
        flow: "DEFAULT",
        data: clone,
        handler: {
          notifyMerchant: function (eventName, data) {
            console.log("notifyMerchant handler function called");
            console.log("eventName => ", eventName);
            console.log("data => ", data);
          },
        },
      };
      dispatch(setIsLoading(true));
      if (window.Paytm && window.Paytm.CheckoutJS) {
        //window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
        // initialze configuration using init method
        window.Paytm.CheckoutJS.init(config)
          .then(function onSuccess() {
            // after successfully updating configuration, invoke JS Checkout
            // loading(true);
            dispatch(setIsLoading(false));
            window.Paytm.CheckoutJS.invoke();
          })
          .catch(function onError(error) {
            console.log("error => ", error);
            dispatch(setIsLoading(false));
          });
        //});
      }
    },
    [data]
  );

  useEffect(() => {
    if (!url || !data || !data?.amount) {
      setState("idle");
    }
    let script = document.querySelector(`script[src="${url}"]`);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/javascript";
      script.src = url;
      script.crossorigin = "anonymous";
      document.body.appendChild(script);
      script.addEventListener("load", () => {
        setScriptLoaded(true);
      });
      //script.addEventListener("load", handleScript);
      script.addEventListener("error", handleScript);
    } else {
      script.addEventListener("load", () => {
        setScriptLoaded(true);
      });
      //script.addEventListener("load", handleScript);
      script.addEventListener("error", handleScript);
    }

    return () => {
      script.removeEventListener("load", handleScript);
      script.removeEventListener("error", handleScript);
    };
  }, [url, data]);
  return [scriptLoaded, handleScript];
};
